export const COLOR_GREEN = "#B0C5A4"
export const COLOR_RED = "#D37676"
export const COLOR_BEIGE = "#EBC49F"
export const PAGE_WIDTH = "1344px"
export const PAGE_PADDING = "40px"